import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { FashionOneComponent } from './fashion/fashion-one/fashion-one.component';

import { WatchComponent } from './watch/watch.component';
import { AndroidComponent } from './servicepage/android/android.component';
import { AboutUsComponent } from '../pages/about-us/about-us.component';
import { WhoweareComponent } from '../pages/who-we-are/who-we-are.component';
import { CareerComponent } from '../pages/career/career.component';
import { AwardComponent } from '../pages/award/award.component';
import { WebsiteDevelopmentComponent } from './servicepage/website-development/website-development.component';
import { WebDesignComponent } from './servicepage/web-design/web-design.component';
import { EcommerceComponent } from './servicepage/ecommerce/ecommerce.component';
import { WordPressComponent } from './servicepage/word-press/word-press.component';
import { CMSComponent } from './servicepage/cms/cms.component';
import { IOSComponent } from './servicepage/i-os/i-os.component';
import { HybridAppComponent } from './servicepage/hybrid-app/hybrid-app.component';
import { ReactAppComponent } from './servicepage/react-app/react-app.component';
import { MobileAppComponent } from './servicepage/mobile-app/mobile-app.component';
import { EnterpriseComponent } from './servicepage/enterprise/enterprise.component';
import { ProductComponent } from './servicepage/product/product.component';
import { SoftwareMaintenanceComponent } from './servicepage/software-maintenance/software-maintenance.component';
import { UIUXDesignComponent } from './servicepage/ui-uxdesign/ui-uxdesign.component';
import { WireframingComponent } from './servicepage/wireframing/wireframing.component';
import { PrototypingComponent } from './servicepage/prototyping/prototyping.component';
import { UXResearchComponent } from './servicepage/uxresearch/uxresearch.component';
import { ManualTestingComponent } from './servicepage/manual-testing/manual-testing.component';
import { AutomatedComponent } from './servicepage/automated/automated.component';
import { PerformanceComponent } from './servicepage/performance/performance.component';
import { SecurityComponent } from './servicepage/security/security.component';
import { UserAcceptanceComponent } from './servicepage/user-acceptance/user-acceptance.component';
import { CustomSoftwareComponent } from './servicepage/custom-software/custom-software.component';
import { SaaSComponent } from './servicepage/saas/saas.component';
import { BrandingComponent } from './servicepage/branding/branding.component';

const routes: Routes = [
  // {
  //   path: 'home1sdsds',
  //   component: FashionOneComponent
  // },
  {
    path: '',
    component: WatchComponent
  },
  {
    path: 'aboutus',
    component: AboutUsComponent
  },  
  {
    path: 'who-we-are',
    component: WhoweareComponent
  }, 
   {
    path: 'career',
    component: CareerComponent
  },  {
    path: 'award',
    component: AwardComponent
  },  
 {
    path: 'Website-development',
    component: WebsiteDevelopmentComponent
  }, 
   {
    path: 'Web-design',
    component: WebDesignComponent
  },
    {
    path: 'Ecommerce-development',
    component: EcommerceComponent
  }, 
   {
    path: 'WordPress-development',
    component: WordPressComponent
  },
    {
    path: 'CMS-development',
    component: CMSComponent
  },  
  {
    path: 'android-app-development',
    component: AndroidComponent
  },  {
    path: 'iOS-app-development',
    component: IOSComponent
  },  {
    path: 'hybrid-app-development',
    component: HybridAppComponent
  },  {
    path: 'react-app-development',
    component: ReactAppComponent
  },  {
    path: 'mobile-app-design',
    component: MobileAppComponent
  }, 
  {
    path: 'custom-software-development',
    component: CustomSoftwareComponent
  }, 
  {
    path: 'enterprise-software-development',
    component: EnterpriseComponent
  }, 
   {
    path: 'saas-development',
    component: SaaSComponent
  }, 
   {
    path: 'product-engineering',
    component: ProductComponent
  },  {
    path: 'software-maintenance-support',
    component: SoftwareMaintenanceComponent
  }, 
  {
    path: 'ui-ux-design',
    component: UIUXDesignComponent
  },  {
    path: 'wireframing',
    component: WireframingComponent
  },  {
    path: 'prototyping',
    component: PrototypingComponent
  },  {
    path: 'ux-research',
    component: UXResearchComponent
  },
  {
    path: 'branding',
    component: BrandingComponent
  },
  {
    path: 'manual-testing',
    component: ManualTestingComponent
  },
  {
    path: 'automated-testing',
    component: AutomatedComponent
  },
  {
    path: 'performance-testing',
    component: PerformanceComponent
  }, {
    path: 'security-testing',
    component: SecurityComponent
  },
  {
    path: 'user-acceptance-testing',
    component: UserAcceptanceComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomeRoutingModule { }
